var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWarningTriangle = function SvgIconWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD55",
    d: "M9.634 1.5a1 1 0 0 1 1.732 0l9.093 15.75a1 1 0 0 1-.866 1.5H1.407a1 1 0 0 1-.866-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.75 13.557c.958 0 1.75.733 1.75 1.712 0 .997-.792 1.731-1.75 1.731C9.774 17 9 16.266 9 15.269c0-.979.774-1.713 1.75-1.713m-1.474-1.43V6h2.985v6.126z"
  })));
};
export { SvgIconWarningTriangle as ReactComponent };
export default __webpack_public_path__ + "images/Icon_Warning_Triangle.svg";